import { render, staticRenderFns } from "./urgent-contact.vue?vue&type=template&id=471eefa0&scoped=true&"
import script from "./urgent-contact.vue?vue&type=script&lang=js&"
export * from "./urgent-contact.vue?vue&type=script&lang=js&"
import style0 from "./urgent-contact.vue?vue&type=style&index=0&id=471eefa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471eefa0",
  null
  
)

export default component.exports